import script from "./workflow-review-breadcrumb.vue?vue&type=script&setup=true&lang=ts"
export * from "./workflow-review-breadcrumb.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__